import {OptionTypeWithoutId} from '../../utils/core/_model'

export interface INotification {
  id: number
  user_id: number
  user_parent_id: number
  notify_text: string
  status: string
  send_date: string
}

export interface INotificationConfigureFormValues {
  notify_num: OptionTypeWithoutId[]
  notify_msisdn: string[]
  exportuseremail: string[] // it refers to notify_email kept it because email selecttion will happen at one component
  notify_email: string[]
  notify_email_cc: string[]
  notify_email_bcc: string[]
  repeat_days: number
  low_balance_amount: number
}

export interface INotificationConfigAPI {
  id: number
  user_id: number
  user_parent_id: number
  low_balance: string[] // Array of string values
  account_balance: string[]
  notify_msisdn: string[] // Array of phone numbers
  notify_email: string[] // Array of email addresses
  notify_email_cc: string[]
  notify_email_bcc: string[]
  repeat_days: number
  low_balance_amount: number
}

export const initNotificationConfigureFormValues: INotificationConfigureFormValues = {
  notify_num: [],
  notify_msisdn: [],
  exportuseremail: [],
  notify_email: [],
  notify_email_cc: [],
  notify_email_bcc: [],
  repeat_days: 1,
  low_balance_amount: 500,
}
